import React from 'react';
import CustomSpinner from './CustomSpinner';

const AppBootstrapLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#f9fafb]">
    <CustomSpinner loading />
  </div>
);

export default AppBootstrapLoader;
